export const resolvePublicUrl = (filePath?: string | null): string => {
    if (!filePath) {
        return '';
    }
    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        return filePath;
    }

    let normalized = filePath.replace(/\\/g, '/');
    if (normalized.startsWith('./')) {
        normalized = normalized.slice(1);
    }
    if (!normalized.startsWith('/')) {
        normalized = `/${normalized}`;
    }

    if (normalized.startsWith('/api/public/')) {
        return encodeURI(normalized);
    }
    if (normalized.startsWith('/public/')) {
        return encodeURI(`/api${normalized}`);
    }
    return encodeURI(normalized);
};
